module.exports = "<div>\n  <div>One</div>\n  <div className=\"u-hidden\">Two</div>\n  <div>Three</div>\n</div>;\n"